import { ReactNode, FC } from 'react'
import clsx from 'clsx'
import { Link } from 'gatsby'
import { Content, Header, Icon, Layout, Menu, Sider } from 'components/common'
import * as styles from '../signed-in/styles.module.css'
import { useAuth0 } from '@auth0/auth0-react'
import NavHeader from '../signed-in/nav-header'
// import { useAppSelector } from 'lib/redux'
// import { selectOrganizationName } from 'lib/redux/auth'
// import { routes } from 'config'

export interface CalendarPageLayoutProps {
  children?: ReactNode
}

// カレンダーページのレイアウト(サイドバーのみ)
const CalendarPageLayout: FC<CalendarPageLayoutProps> = ({ children }) => {
  const { user } = useAuth0()
  // const organizationName = useAppSelector(selectOrganizationName)
  // console.log(user)
  const userType = user['https://my-app.example.com/roles'][0]

  // const items = [
  //   {
  //     label: <Link to={routes.home}>ホーム</Link>,
  //     key: routes.home,
  //     icon: <Icon.HomeFilled />,
  //   },
  //   {
  //     label: <Link to={'/calendar'}>予約カレンダー</Link>,
  //     key: 'calendar',
  //     icon: <Icon.CalendarFilled />,
  //   },
  //   {
  //     label: '設定',
  //     key: 'settings',
  //     icon: <Icon.SettingFilled />,
  //     children: [
  //       {
  //         label: <Link to={'/calendar/select'}>表示施設選択</Link>,
  //         key: 'aaaa',
  //       },
  //       {
  //         label: <Link to={'/calendar/observer'}>オブザーバー管理</Link>,
  //         key: 'bbb',
  //       },
  //     ],
  //   },
  // ]

  return (
    <>
      <Header className={clsx(styles.header)}>
        <NavHeader title="予約一覧" subtitle={userType} />
      </Header>

      <Content className={clsx(styles.content)}>{children}</Content>
    </>
  )
}

export default CalendarPageLayout
